import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    base: '/webmall/',
    mode: 'history',
    routes: [
        {
            path: '*',
            name: '404',
            meta: {
                title: '404'
            },
            component: function (resolve) {
                require(['@/views/404'], resolve)
            }
        },
        {
            path: '/neterror',
            name: 'net-error',
            meta: {
                title: '网络错误'
            },
            component: function (resolve) {
                require(['@/views/netError'], resolve)
            }
        },
        { path : "/", redirect : "/packages/index" },
        {
            path: "/login",
            name: "login",
            meta: {
                title: '登录'
            },
            component: function (resolve) {
                require(['@/views/login'], resolve)
            }
        },
        {
            path: "/test",
            name: "test",
            meta: {
                title: '调试页面'
            },
            component: function(resolve) {
                require(['@/views/test'], resolve)
            }
        },
        {
            path: "/index",
            name: "index",
            meta: {
                title: '首页'
            },
            component: function(resolve) {
                require(['@/views/homepage/index'], resolve)
            }
        },
        {
            path: "/packages/index",
            name: "package-list",
            meta: {
                title: '单国流量套餐列表'
            },
            component: function (resolve) {
                require(['@/views/packages/index'], resolve)
            }
        },
        {
            path: "/order/payment",
            name: "order-payment",
            meta: {
                title: '订单支付'
            },
            component: function (resolve) {
                require(['@/views/order/payment'], resolve)
            }
        },
        {
            path: "/order/success",
            name: "order-success",
            meta: {
                title: '订单支付成功'
            },
            component: function (resolve) {
                require(['@/views/order/success'], resolve)
            }
        },
        {
            path: "/order/jump",
            name: "order-jump",
            meta: {
                title: 'Loading...'
            },
            component: function (resolve) {
                require(['@/views/order/jump'], resolve)
            }
        },
        {
            path: "/order/waitingForConfirm",
            name: "waiting-for-confirm",
            meta: {
                title: '订单支付待确认'
            },
            component: function (resolve) {
                require(['@/views/order/waitingForConfirm'], resolve)
            }
        },
        {
            path: "/point",
            name: "point-index",
            meta: {
                title: '会员积分首页'
            },
            component: function (resolve) {
                require(['@/views/user/point/index'], resolve)
            }
        },
        {
            path: "/point/history",
            name: "point-history",
            meta: {
                title: '会员积分明细'
            },
            component: function (resolve) {
                require(['@/views/user/point/history'], resolve)
            }
        },
        {
            path: "/point/exchange",
            name: "point-exchange",
            meta: {
                title: '积分兑换'
            },
            component: function (resolve) {
                require(['@/views/user/point/exchange'], resolve)
            }
        },
        {
            path: "/memberShip",
            name: "member-ship",
            meta: {
                title: '会员权益首页'
            },
            component: function (resolve) {
                require(['@/views/user/memberShip/index'], resolve)
            }
        },
        {
            path: "/memberShip/benefit",
            name: "member-benefit",
            meta: {
                title: '会员权益列表'
            },
            component: function (resolve) {
                require(['@/views/user/memberShip/benefit'], resolve)
            }
        },
        {
            path: "/memberShip/faq",
            name: "member-faq",
            meta: {
                title: '常见问题'
            },
            component: function (resolve) {
                require(['@/views/user/memberShip/faq'], resolve)
            }
        },
        {
            path: "/memberShip/policy",
            name: "member-policy",
            meta: {
                title: '会员隐私'
            },
            component: function (resolve) {
                require(['@/views/user/memberShip/policy'], resolve)
            }
        },
        {
            path: "/memberShip/introduce",
            name: "member-introduce",
            meta: {
                title: '会员介绍'
            },
            component: function (resolve) {
                require(['@/views/user/memberShip/introduce'], resolve)
            }
        },
        {
            path: '/memberShip/giveSet',
            name: 'give-set',
            meta: {
                title: '赠送流量设置'
            },
            component: function (resolve) {
                require(['@/views/user/memberShip/giveSet'], resolve)
            }
        },
        {
            path: "/faq/index",
            name: "faq-index",
            meta: {
                title: '常见问题'
            },
            component: function (resolve) {
                require(['@/views/faq/index'], resolve)
            }
        },
        {
            path: "/faq/deviceList",
            name: "device-list",
            meta: {
                title: '全部设备'
            },
            component: function (resolve) {
                require(['@/views/faq/deviceList'], resolve)
            }
        },
        {
            path: "/faq/faqList",
            name: "faq-list",
            meta: {
                title: '常见问题'
            },
            component: function (resolve) {
                require(['@/views/faq/faqList'], resolve)
            }
        },
        {
            path: "/faq/otherFaqList",
            name: "faq-list",
            meta: {
                title: '常见问题'
            },
            component: function (resolve) {
                require(['@/views/faq/otherFaqList.vue'], resolve)
            }
        },
        {
            path: "/faq/otherFaqDetail",
            name: "faq-list",
            meta: {
                title: '常见问题详情'
            },
            component: function (resolve) {
                require(['@/views/faq/otherFaqDetail.vue'], resolve)
            }
        },
        {
            path: "/faq/faqDetail",
            name: "faq-detail",
            meta: {
                title: '详情'
            },
            component: function (resolve) {
                require(['@/views/faq/faqDetail'], resolve)
            }
        },
        {
            path: "/device/index",
            name: "device-index",
            meta: {
                title: '设备手册'
            },
            component: function (resolve) {
                require(['@/views/device/index'], resolve)
            }
        },
        {
            path: "/device/deviceDetail",
            name: "device-detail",
            meta: {
                title: '设备详情'
            },
            component: function (resolve) {
                require(['@/views/device/deviceDetail'], resolve)
            }
        },
        {
            path: "/vpn/faqList",
            name: "vpn-faq",
            meta: {
                title: "VPN常见问题"
            },
            component: function (resolve) {
                require(['@/views/vpn/faqList'], resolve)
            }
        },

        {
            path: "/ota/faq/:classes",
            name: "ota-faq",
            meta: {
                title: "ota常见问题"
            },
            component: function (resolve) {
                require(['@/views/ota/faqList'], resolve)
            }
        },
        {
            path: "/vpn/faqDetail",
            name: "vpn-faq-detail",
            meta: {
                title: '详情'
            },
            component: function (resolve) {
                require(['@/views/vpn/faqDetail'], resolve)
            }
        },
        {
            path: "/ota/faq/:classes/faqDetail",
            name: "ota-faq-detail",
            meta: {
                title: '详情'
            },
            component: function (resolve) {
                require(['@/views/ota/faqDetail'], resolve)
            }
        },
        {
            path: "/deviceGuide/index",
            name: "device-guide-index",
            meta: {
                title: "设备引导"
            },
            component: function(resolve) {
                require(['@/views/deviceGuide/index'], resolve)
            }
        },
        {
            path: "/petDeviceGuide/index",
            name: "device-guide-index",
            meta: {
                title: "宠物设备引导"
            },
            component: function(resolve) {
                require(['@/views/petDeviceGuide/index'], resolve)
            }
        },
        {
            path: "/deviceGuide/deviceDetail",
            name: "device-guide-detail",
            component: function (resolve) {
                require(['@/views/deviceGuide/deviceDetail'], resolve)
            }
        },
        {
            path: "/petDeviceGuide/deviceDetail",
            name: "device-guide-detail",
            component: function (resolve) {
                require(['@/views/petDeviceGuide/deviceDetail'], resolve)
            }
        },
        {
            path: "/deviceGuide/deviceDetailChange",
            name: "device-detail-change",
            component: function (resolve) {
                require(['@/views/deviceGuide/deviceDetailChange'], resolve)
            }
        },
        {
            path: "/petDeviceGuide/deviceDetailChange",
            name: "device-detail-change",
            component: function (resolve) {
                require(['@/views/petDeviceGuide/deviceDetailChange'], resolve)
            }
        },
        {
            path: '/guide/newUser',
            name: 'new-user-guide',
            component: function(resolve) {
                require(['@/views/guide/newUser'], resolve)
            }
        },
        {
            path: '/invite/shareCode',
            name: '拉新分享',
            component: function(resolve) {
                require(['@/views/inviteNew/share'], resolve)
            }
        },
        {
            path: '/invite/newRegister',
            name: '新用户填写邀请码',
            meta: {
                title: "新用户填写邀请码"
            },
            component: function(resolve) {
                require(['@/views/inviteNew/newRegister'], resolve)
            }
        },
        {
            path: '/invite/invitationHistory',
            name: '拉新记录',
            component: function(resolve) {
                require(['@/views/inviteNew/invitationHistory'], resolve)
            }
        },
        {
            path: '/esim/redemption',
            name: 'esim兑换',
            component: function(resolve) {
                require(['@/views/esimRedmption/esimRedmption'], resolve)
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js